import React from 'react';

const Logo = ({ 
  size = 'text-5xl', 
  className = '',
  carColor = 'text-white',
  vyColor = 'text-[#F5A623]'
}) => {
  return (
    <h1 className={`font-black tracking-tight ${size} ${className}`}>
      <span className={carColor}>Car</span>
      <span className={vyColor}>vy</span>
    </h1>
  );
};

export default Logo;

